module.exports = {"0":{"background":"black","logoLarge":"moneyroad_white_green.png","logoMiddle":"mrlogo.png"}}